import React, { PropsWithChildren } from "react";

import styles from "./EmptyText.module.css";

const EmptyText: React.FC<PropsWithChildren<Record<never, any>>> = ({
  children,
}) => <div className={styles.text}>{children}</div>;

export default EmptyText;
